export default "__VITE_ASSET__3aa4e1cc__"